import type { TFunction } from 'i18next';

/**
 * Who an activity entry names, in the reader's language.
 *
 * Whatever the product does by itself is recorded under a fixed English label
 * that `enum.actorLabel` has words for. A person is recorded under their own
 * name, which matches nothing there and reads as itself.
 *
 * A payment provider is recorded as `billing:<provider>`, so the back office can
 * say which provider it was. The owner is told only that it was the payment
 * provider, and the stored label could not be looked up as it is in any case:
 * i18next reads whatever comes before a colon as a namespace, so
 * `enum.actorLabel.billing:payplus` finds nothing even when the entry exists.
 */
export function actorName(actorLabel: string, t: TFunction): string {
  const key = actorLabel.startsWith('billing:') ? 'billing' : actorLabel;
  return t(`enum.actorLabel.${key}`, { defaultValue: actorLabel });
}
